import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DriverSearchModule } from './driver-search/driver-search.module';
import { DeliveryShipperFeatureDriverRoutingModule } from './delivery-shipper-feature-driver-routing.module';

@NgModule({
  imports: [CommonModule, DeliveryShipperFeatureDriverRoutingModule, DriverSearchModule]
})
export class DeliveryShipperFeatureDriverModule {}
